import styles from "../css/modules/components.module.scss";
import { dateTimeFormatter } from "../utils/format";

const startTime = Date.now();

export function AppVersion() {
  const buildTime = import.meta.env.PROD ? +import.meta.env.REACT_APP_BUILD_VERSION : startTime;
  const buildId = import.meta.env.PROD ? import.meta.env.REACT_APP_BUILDID : 0;
  return (
    <div className={styles.appVersion}>
      app version: {import.meta.env.REACT_APP_VERSION}.{buildId}
      <br /> build time: {dateTimeFormatter(buildTime)}
    </div>
  );
}
